import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { Button } from '@/shared/ui/button/Button';
import { AlertTriangle } from 'lucide-react';

export function RouteErrorBoundary() {
  const error = useRouteError();

  let title = 'Algo salió mal';
  let message = 'Ocurrió un error inesperado. Intenta recargar la página.';

  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}`;
    message = error.statusText || message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg p-6 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary-muted">
        <AlertTriangle className="h-8 w-8 text-secondary" />
      </div>
      <h1 className="mb-2 text-2xl font-display font-bold text-text-primary">
        {title}
      </h1>
      <p className="mb-6 max-w-md text-text-secondary">{message}</p>
      <div className="flex gap-3">
        <Button onClick={() => window.location.reload()}>Recargar página</Button>
        <Button variant="ghost" onClick={() => (window.location.href = '/login')}>
          Volver al login
        </Button>
      </div>
    </div>
  );
}
